// Vendor Libs
import cloneDeep from 'lodash.clonedeep';

// Action Types
import {actionTypes} from '../action-types';
import {limitParamsOptions} from '../../helpers/constants';

const initialState = {
  results: [],
  total: 0,
  endpoint: '',
  params: {
    page: 0,
    limit: limitParamsOptions[0].value,
  },
  searchType: '',
  errorStatus: undefined,
  errorMessage: '',
  loading: false,
};

const actions = {
  [actionTypes.RESULTS_STATE_CLEANUP]: () => initialState,

  [actionTypes.RESULTS_LOADING_FRESH_RESULTS_DONE]: (_, payload) => ({
    ...initialState,
    ...payload,
  }),

  [actionTypes.RESULTS_UPDATING_PAGE_DONE]: (state, payload) => ({
    ...cloneDeep(state),
    ...payload,
  }),

  [actionTypes.RESULTS_UPDATING_PAGE_LIMIT_DONE]: (state, payload) => ({
    ...cloneDeep(state),
    ...payload,
  }),

  [actionTypes.RESULTS_EMIT_ERROR]: (state, payload) => ({
    ...cloneDeep(state),
    ...payload,
  }),

  [actionTypes.RESULTS_LOADING]: (state, payload) => ({
    ...cloneDeep(state),
    loading: payload,
  }),
};

export const resultsReducer = (state = initialState, action) =>
  actions[action.type] ? actions[action.type](state, action.payload) : state;
